export default __webpack_public_path__ + "static/media/cup-of-coffee.8a568aa8.png";